import ViewSettings, { IViewSettings } from "./ViewSettings"

export const SHOW_INACTIVE_ASSETS_DEFAULT = false

export interface IViewSettingsInventory {
    showInactiveAssets?: boolean
}

export default class ViewSettingsInventory extends ViewSettings implements IViewSettings {
    showInactiveAssets: boolean = SHOW_INACTIVE_ASSETS_DEFAULT

    constructor(data: IViewSettingsInventory) {
        super()
        if (typeof data.showInactiveAssets !== "undefined") {
            this.showInactiveAssets = data.showInactiveAssets
        }
    }

    get isDefault() {
        return this.showInactiveAssets === SHOW_INACTIVE_ASSETS_DEFAULT
    }
}
